import { Component, Inject, ViewChild } from '@angular/core';
import { Charge } from '../../../../models/entities/charge';
import { ChargesService } from '../../../../services/charges/charges.service';
import { LoadingModalComponent } from '../../shared/loading-modal/loading-modal.component';
import { GrowlerService } from '../../../shared/growler/growler.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { LoadingDialogComponent, LoadingDialogInput } from '../../shared/loading-dialog/loading-dialog.component';
import { BulkChargeEditFormComponent } from '../bulk-charge-edit-form/bulk-charge-edit-form.component';
import { finalize } from 'rxjs/operators';
import { MatDialogSizes } from '../../../../enums/mat-dialog-sizes.enum';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UntypedFormArray } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';

export interface BulkChargeEditorDialogInput
{
    charges: Charge[];
}

export interface BulkChargeEditorDialogOutput
{
    success: boolean;
}

@UntilDestroy()
@Component({
    selector: 'lf-bulk-charge-editor',
    templateUrl: './bulk-charge-editor.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MatDialogModule,
        BulkChargeEditFormComponent,
    ],
})
export class BulkChargeEditorComponent
{
    static readonly width: MatDialogSizes = MatDialogSizes.LG;
    loadingModalComponent = LoadingModalComponent;
    isSaving = false;

    @ViewChild('bulkChargeEditForm') bulkChargeEditForm: BulkChargeEditFormComponent;

    constructor(
            private _dialogRef: MatDialogRef<BulkChargeEditorComponent>,
            private _chargesService: ChargesService,
            private _growler: GrowlerService,
            private _dialog: MatDialog,
            @Inject(MAT_DIALOG_DATA) public data: BulkChargeEditorDialogInput,
    ) {
    }

    saveCharges() {
        if (!this.bulkChargeEditForm.model.valid) {
            this.bulkChargeEditForm.dirtyTheForm();
            return;
        }
        const ref = this._dialog.open(LoadingDialogComponent, {
            data: <LoadingDialogInput>{
                title: 'Updating Charges...',
            },
        });
        this.isSaving = true;

        // TODO: Can this be done better?
        this.bulkChargeEditForm.model.get('activeAfter').setValue(this.bulkChargeEditForm.model.get('activeAfter').value?.format('YYYY-MM-DD'));
        this.bulkChargeEditForm.model.get('paymentDueOn').setValue(this.bulkChargeEditForm.model.get('paymentDueOn').value?.format('YYYY-MM-DD'));
        const lateFees = <UntypedFormArray>this.bulkChargeEditForm.model.controls['lateFees'];
        lateFees.controls.forEach((control, index) => {
            control.get('oneTimeLateFeeApplies')?.setValue(control.get('oneTimeLateFeeApplies')?.value?.format('YYYY-MM-DD'));
            control.get('recurringLateFeeBegins')?.setValue(control.get('recurringLateFeeBegins')?.value?.format('YYYY-MM-DD'));
        });

        this._chargesService.updateCharges(null, {
            chargeIds: this.data.charges.map(c => c.id),
            charge: this.bulkChargeEditForm.getFormValue(),
        })
                .pipe(finalize(() => {
                    this.isSaving = false;
                }))
                .subscribe({
                    next: () => {
                        ref.close();
                        this._dialogRef.close(<BulkChargeEditorDialogOutput>{success: true});
                        this._growler.success('Charges Saved', 'Updates to charges were saved successfully.');
                    },
                    error: () => {
                        ref.close();
                        this._growler.error('Error', 'Could not update charges.');
                    },
                });
    }
}
